<template>
    <section class="photos" @click="closePhotos()" v-if="open" @keydown="keyUp" tabindex="0">
        <div class="photo" @click.prevent.stop tabindex="1" :class="getActive.orientation">
            <pinch-zoom ref="pinch">
                <img :src="getActiveUrl" class="photo-image">
            </pinch-zoom>
            <div @click="openUser()" class="photo-author" v-if="getActive && getActive.author">
                <div class="photo-author__avatar" :style="{backgroundImage: 'url(' + getActive.author.avatar + ')'}"></div>
                <p class="photo-author__name">{{getActive.author.firstname + " " + getActive.author.lastname}}</p>
            </div>
        </div>
        <div class="photo-close" @click="closePhotos()">
            <img src="@/assets/images/icons/icon_close-w.svg">
        </div>
        <div class="photo-right" v-if="canNext" @click.stop="nextPhoto()">
            <img src="@/assets/images/icons/icon_next.svg">
        </div>
        <div class="photo-left" v-if="canPrev" @click.stop="prevPhoto()">
            <img src="@/assets/images/icons/icon_next.svg">
        </div>
    </section>
</template>
<script>
import PinchZoom from 'vue-pinch-zoom';
import { mapState } from 'vuex';

export default {
    name: 'ModalPhoto',
    data: () => {
        return {
            scrollable: true,
            start: null
        }
    },
    components: {
        PinchZoom
    },
    computed: {
        ...mapState({
            open: state => state.photos.open
        }),
        photos () {
            return this.$store.getters.getPhotoItems
        },
        index () {
            return this.$store.getters.getPhotoIndex
        },
        getActive () {
            return this.$store.getters.getPhoto
        },
        getActiveUrl () {
            let photo = this.$store.getters.getPhoto;
            return typeof photo === 'string' ? photo : photo.url ? photo.url : photo.large
        },
        canPrev() {
            return this.index > 0
        },
        canNext() {
            return this.index + 1 < this.photos.length
        }
    },
    methods: {
        openUser() {
            this.closePhotos()
            this.$router.push(`/user/${this.getActive.author.id}`)
        },
        closePhotos () {
            this.$store.dispatch('setPhotosState', false)
        },
        nextPhoto() {
            this.$store.dispatch('nextPhoto')
        },
        prevPhoto() {
            this.$store.dispatch('prevPhoto')
        },
        keyUp(val) {
            if (val.keyCode === 39) {
                this.nextPhoto()
            } else if (val.keyCode === 37) {
                this.prevPhoto()
            }
        }
    },
    watch: {
        open(val) {
            setTimeout(() => {
                let modal = document.querySelector('.photos');
                modal && val ? modal.focus() : ''
            }, 100)
        }
    }
}
</script>